import styled from 'styled-components'

export const ApplePayButtonContainer = styled.div`
  width: 100%;
  margin: 32px 0;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 200px;
    height: 40px;
  }
`

export const OrLine = styled.div`
  border-bottom: 1px solid #ccc;
  display: block;
  line-height: 0.1;
  margin: 35px 0;
  text-align: center;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    margin: 25px 0;
  }
`

export const Or = styled.span`
  background: #fff;
  padding: 0 10px;
`
